export default __webpack_public_path__ + "static/media/visa.0ee36064.svg";